import { createStyles, rem } from '@mantine/core'

export default createStyles((theme) => {
  return {
    root: {
      '.card-item': {
        backgroundColor: 'transparent',
      },
      gap: rem(40),
      [theme.fn.largerThan('sm')]: {
        gap: rem(80),
      },
    },
    processRoot: {},
    processBar: {},
    header: {
      display: 'flex',
      gap: rem(24),
      [theme.fn.smallerThan('sm')]: {
        flexDirection: 'column',
      },
      [theme.fn.largerThan('sm')]: {
        justifyContent: 'space-between',
        alignItems: 'flex-end',
      },
    },
    heading: {},
    headingWrapper: {
      display: 'flex',
      gap: 8,
      [theme.fn.smallerThan('sm')]: {
        flexDirection: 'column',
      },
      [theme.fn.largerThan('sm')]: {
        justifyContent: 'space-between',
        alignItems: 'center',
      },
    },
    pillarBar: {
      display: 'flex',
      gap: 8,
      [theme.fn.smallerThan('sm')]: {
        paddingRight: 16,
      },
    },
    pillarBtn: {
      fontWeight: 'normal',
      paddingLeft: 16,
      paddingRight: 16,
    },
  }
})
